import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";

import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";
import DatePicker from "react-datepicker";
import RecipeOrdering from "./RecipeOrdering ";

import "react-datepicker/dist/react-datepicker.css";
import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "../../../../config/config";

const expinyearsOptions = [
  {
    name: "",
  },
  {
    name: "Months",
  },
  {
    name: "Years",
  },
];

const LaxmisKitchenRecipesList = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [exptabshow, setExptabshow] = useState(false);
  const [textline1, settextline1] = useState("");
  const [titleerr, settitleerr] = useState("");
  const [videoerr, setvideoerr] = useState("");

  const [date, setdate] = useState("");
  const [date2, setdate2] = useState(new Date());
  const [link, setlink] = useState("");
  const [videoUrl, setvideoUrl] = useState("");
  const [linkerr, setlinkErr] = useState("");
  const [title, settitle] = useState("");
  const [bannerimg, setbannerimg] = useState("");
  const [bannerimgerr, setbannerimgErr] = useState("");
  const [bannerimgnotpresent, setbannerimgnotpresent] = useState("");
  const [type, settype] = useState("Add");
  const [mbbannerimg, setmbbannerimg] = useState("");
  const [mbbannerimgerr, setmbbannerimgErr] = useState("");
  const [mbImgNotPresent, setmbImgNotPresent] = useState("");

  const [updateModel, setUpdateModel] = useState(false);
  const [showMobImg, setShowMobImg] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");

  const [bannerid, setbannerid] = useState("");

  const [toastlist, setToastList] = useState([]);

  const [orderingModalOpen, setOrderingModalOpen] = useState(false);

  let toastProperties = null;

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Banner ${
            updateModel ? "updated" : "added"
          } Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "Banner deleted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setUpdateModel(false);
    setShow(true);
    settype("Add");
    setShowMobImg(false);
    setShowDesktopImg(false);
    setdate2(new Date());
    setvideoUrl("");
    settextline1("");
    settitleerr("");
    setbannerimgErr("");
    setvideoerr("");
    setdate("");
    setlink("");
    setbannerimg("");
    setmbbannerimg("");
  };

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getBannerImages");
    axios
      .get(`${config.api_url}laxmis-kitchen/recipes`)
      .then((response) => {
        const templist = response.data.sort((a, b) => a.position - b.position);
        setList(templist);
        setLoading(false);
      })
      .catch((error) => setLoading(false));
  }, []);

  const handleShowForUpdate = (rowData) => {
    console.log(rowData);
    setUpdateModel(true);
    setShow(true);
    settitle(rowData.title);
    setdate(rowData.date);
    settype("Update");
    settitleerr("");
    setvideoerr("");
    setbannerimgErr("");
    setdate2(new Date(rowData.date2));
    setvideoUrl(rowData.videoUrl);
    //setmbbannerimg(Imageurldata + rowData.mobileImageUrl.replaceAll("\\", "/"));
    setbannerimg(Imageurldata + rowData.desktopImageUrl.replaceAll("\\", "/"));
    // setmbImgNotPresent(
    //   rowData.mobileImageUrl.replaceAll("\\", "/") ? false : true
    // );
    setbannerimgnotpresent(
      rowData.desktopImageUrl.replaceAll("\\", "/") ? false : true
    );

    setbannerid(rowData._id);

    setShowMobImg(false);
    setShowDesktopImg(false);
  };

  const updateBanner = () => {
    var formData = new FormData();
    formData.append("title", title);

    formData.append("videoUrl", videoUrl);
    formData.append("date", date);
    formData.append("date2", date2);
    if (mbImgNotPresent) {
      formData.append("mobileImageUrl", mbbannerimg);
      setmbImgNotPresent(false);
    }

    if (bannerimgnotpresent) {
      formData.append("desktopImageUrl", bannerimg);
      setbannerimgnotpresent(false);
    }

    let url = new URL(urldata + "admin/updateBannerImages");
    formData.append("id", bannerid);
    //url.searchParams.append('id', bannerid)
    var decoded = decodeURIComponent(url);

    axios
      .post(`${config.api_url}laxmis-kitchen/recipe/update`, formData)
      .then((response) => {
        const templist = response.data.sort((a, b) => a.position - b.position);
        setList(templist);
        showToast("success");
        setShow(false);
      });
  };

  const createbanner = () => {
    var formData = new FormData();
    formData.append("title", title);

    formData.append("videoUrl", videoUrl);
    formData.append("date", date);
    formData.append("date2", date2);
    formData.append("mobileImageUrl", mbbannerimg);
    formData.append("desktopImageUrl", bannerimg);

    let url = new URL(urldata + "admin/addBannerImages");

    axios({
      method: "post",
      url: `${config.api_url}laxmis-kitchen/recipe/new`,
      data: formData,
      // withCredentials: true,
    })
      .then((response) => {
        // settextline1("");
        // settextline2("");
        // settextline3("");
        // setlink("");
        // setbannerimg("");
        // setmbbannerimg("");
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        console.log(list);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        // showToast("danger");
      });
  };

  const submit = () => {
    console.log(date2);
    var formIsValid = true;
    if (!bannerimg) {
      formIsValid = false;
      setbannerimgErr("*Please upload desktop banner image.");
    } else {
      setbannerimgErr("");
    }
    if (title === "") {
      formIsValid = false;
      settitleerr("*Please fill title field.");
    } else {
      settitleerr("");
    }
    if (videoUrl === "") {
      formIsValid = false;
      setvideoerr("*Please fill video url field");
    } else {
      setvideoerr("");
    }

    // if (!mbbannerimg) {
    //   formIsValid = false;
    //   setmbbannerimgErr("*Please upload mobile  banner image.");
    // } else {
    //   setmbbannerimgErr("");
    // }

    // <<<<<<< HEAD
    // if (bannerimg) {
    //   if (bannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setbannerimgErr("*File should be less than 300Kb.");
    //   }
    // }
    // if (mbbannerimg) {
    //   if (mbbannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setmbbannerimg("*File should be less than 300Kb.");
    //   }
    // }

    // =======
    // >>>>>>> vijay
    if (formIsValid) {
      if (updateModel) {
        updateBanner();
      } else {
        createbanner();
      }
    }
  };
  const handleCheck = (rowData) => {
    // console.log(rowData)dvf
    // console.log(rowData.checked)
    var formData = new FormData();
    formData.append("id", rowData._id);
    formData.append("checked", !rowData.checked);
    console.log(rowData._id);
    console.log(!rowData.checked);
    rowData.checked = !rowData.checked;
    axios
      .post(`${config.api_url}laxmis-kitchen/recipe/update`, formData)
      .then((response) => {
        const templist = response.data.sort((a, b) => a.position - b.position);
        setList(templist);
        showToast("success");
      });
    //console.log(!checked)
    // setChecked(!checked)
    // console.log(checked)
  };
  const deleteBtnClick = (id) => {
    setLoading(true);
    let data = {};
    data.id = id;

    let url = new URL(urldata + "admin/deleteBannerImage");

    axios
      .post(`${config.api_url}laxmis-kitchen/recipe/delete`, data)
      .then((response) => {
        const templist = response.data.sort((a, b) => a.position - b.position);
        setList(templist);
        setLoading(false);
        showToast("delete");
      });
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="addjobinlist text-right mb-4">
        <Button title="Add Recipe" onClick={handleShow} />
        <Button
          title="Reorder Recipes"
          onClick={() => setOrderingModalOpen(true)}
          style={{ marginLeft: "10px" }}
        />
      </div>

      <MaterialTable
        title="Recipes List"
        columns={[
          {
            title: "Mark featured recipes",
            render: (rowData) => (
              <div className="d-f">
                <label>
                  <input
                    type="checkbox"
                    defaultChecked={rowData.checked}
                    onChange={() => handleCheck(rowData)}
                  />
                </label>
              </div>
            ),
          },
          { title: "Title", field: "title" },
          { title: "Date", field: "showDate" },
          { title: "Video url", field: "videoUrl" },

          // {
          //   field: "url",

          //   title: "Mobile Image  ",
          //   render: (rowData) => (
          //     <div className="d-f">
          //       <Button
          //         title="View"
          //         onClick={() => {
          //           window.open(
          //             Imageurldata +
          //               rowData.mobileImageUrl.replaceAll("\\", "/"),
          //             "_blank"
          //           );
          //         }}
          //       ></Button>
          //     </div>
          //   ),
          // },
          {
            field: "url",

            title: "Image  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title="View"
                  onClick={() => {
                    window.open(
                      Imageurldata +
                        rowData.desktopImageUrl.replaceAll("\\", "/"),
                      "_blank"
                    );
                  }}
                ></Button>
              </div>
            ),
          },
          {
            field: "url",

            title: "Action  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title=" Update"
                  onClick={() => {
                    handleShowForUpdate(rowData);
                  }}
                ></Button>
                <Button
                  title=" Delete"
                  onClick={() => deleteBtnClick(rowData._id)}
                ></Button>
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />

      <Modal
        {...props}
        //   size="lg"
        //   aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="addbannerModel"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          <div className="title">{type} recipe</div>

          <Row>
            <Col lg={3} className="column">
              <div className="titleitem">{type} title </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={title}
                onChange={(e) => settitle(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{titleerr} </div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>

            <Col lg={3} className="column">
              <div className="titleitem">{type} date </div>
            </Col>
            <Col lg={9} className="column">
              <DatePicker
                selected={date2}
                onChange={(date) => setdate2(date)}
              />

              {/* <div className="count">{textline1.length}/31</div>   <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />*/}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} video url </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={videoUrl}
                onChange={(e) => setvideoUrl(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{videoerr} </div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>

            <Col lg={3} className="column">
              <div className="titleitem">{type} Image</div>
              <div className="desc">Size :- 420 × 500 px</div>
            </Col>
            <Col lg={9} className="column">
              <input
                id="bannerImage"
                accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG"
                type="file"
                onChange={(e) => {
                  setbannerimg(e.target.files[0]);
                  setShowDesktopImg(true);
                  setbannerimgnotpresent(true);
                }}
                name="passport_proof_upload"
              />

              <label for="bannerImage" className="d-f" id="file-drag">
                <img src={upload} class="img-fluid" />
                <div class="chooseTxt">Choose File</div>
              </label>

              <div className="d-f jc-sb">
                <div className="fileTxt">File Format : JPG / PNG</div>
              </div>
              <div className="err">{bannerimgerr} </div>

              <div>
                {bannerimg !== "" && (
                  <img
                    src={
                      showDesktopImg
                        ? URL.createObjectURL(bannerimg)
                        : bannerimg
                    }
                    className="img-fluid"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
            </Col>
          </Row>
          <div className="btnContainer mt-4">
            <Button onClick={submit} title="SUBMIT" />
          </div>
        </Modal.Body>
      </Modal>
      <Toast toastList={toastlist} position="top-right" />
      <RecipeOrdering
        isOpen={orderingModalOpen}
        onClose={() => setOrderingModalOpen(false)}
        recipes={list}
        onOrderUpdated={(newList) => setList(newList)} // <-- update table
      />
    </>
  );
};

export default LaxmisKitchenRecipesList;

// updateBannerImages
